import {
  validFileTypes,
  type File as AttachmentFile,
} from '@ohrm/core/util/validation/rules';

export const PAYSLIP_TEMPLATE_DOCX_MIME =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export const PAYSLIP_TEMPLATE_DOCX_ACCEPT = `.docx,${PAYSLIP_TEMPLATE_DOCX_MIME}`;

export function isDocxFile(
  file: {name?: string; type?: string} | null,
): boolean {
  if (!file?.name) {
    return false;
  }

  if (file.type === PAYSLIP_TEMPLATE_DOCX_MIME) {
    return true;
  }

  return file.name.toLowerCase().endsWith('.docx');
}

export function validPayslipTemplateDocxFile() {
  const mimeValidator = validFileTypes([PAYSLIP_TEMPLATE_DOCX_MIME]);

  return (file: AttachmentFile | null): boolean | string => {
    if (!file) {
      return true;
    }

    if (isDocxFile(file)) {
      return true;
    }

    return mimeValidator(file);
  };
}

export function normalizePayslipTemplateDocxAttachment<
  T extends {name?: string; type?: string; base64?: string; size?: number},
>(attachment: T | null): T | null {
  if (!attachment?.name || !attachment?.base64) {
    return attachment;
  }

  if (!isDocxFile(attachment)) {
    return attachment;
  }

  return {
    ...attachment,
    type: PAYSLIP_TEMPLATE_DOCX_MIME,
  };
}
